import {
  CHINA_PSB_FILING,
  CHINA_PSB_FILING_BADGE_URL,
  CHINA_PSB_FILING_VERIFICATION_URL,
} from '@/shared/lib/chinaPsbFiling'
import { isChinaFacingLexClient } from '@/shared/lib/isChinaFacingLexClient'
import { cn } from '@/shared/lib/utils'

type ChinaPsbFilingFooterLayout = 'stacked' | 'inline'

type ChinaPsbFilingFooterProps = {
  className?: string
  /** `inline` lays out all fields on one row (main app shell). */
  layout?: ChinaPsbFilingFooterLayout
}

function ChinaPsbFilingRecordLink() {
  return (
    <a
      href={CHINA_PSB_FILING_VERIFICATION_URL}
      target='_blank'
      rel='noopener noreferrer'
    >
      <img
        src={CHINA_PSB_FILING_BADGE_URL}
        alt=''
        className='mr-1 inline-block size-4 shrink-0'
      />
      {CHINA_PSB_FILING.recordNumber}
    </a>
  )
}

export function ChinaPsbFilingFooter({ className }: ChinaPsbFilingFooterProps) {
  if (!isChinaFacingLexClient()) {
    return null
  }

  return (
    <footer
      className={cn(
        'bg-background px-4 text-xs leading-relaxed text-muted-foreground',
        className
      )}
      aria-label='公安备案信息'
    >
      <div className='mx-auto flex max-w-full flex-wrap items-center justify-center gap-x-4 gap-y-1'>
        <span>开办者名称：{CHINA_PSB_FILING.operatorName}</span>
        <span>
          <span>公安备案号：</span>
          <ChinaPsbFilingRecordLink />
        </span>
        <span>备案地公安机关：{CHINA_PSB_FILING.authority}</span>
        <span>联网备案时间：{CHINA_PSB_FILING.registeredAt}</span>
      </div>
    </footer>
  )
}
